<template>
  <v-card class="pa-5">
    <v-btn absolute flat small fab @click="$emit('close')" class="close-btn">x</v-btn>
    <p v-if="auditData">{{JSON.stringify(JSON.parse(auditData), null, 2)}}</p>
    <p v-if="data">{{ data }}</p>
  </v-card>
</template>

<script>
  export default {
    props: ['auditData', 'data'],
  };
</script>

<style lang="scss" scoped>
  .card {
    overflow: hidden;
  }
  p {
    word-wrap: break-word;
  }
  .close-btn {
    top: 8px;
    right: 8px;;
  }
</style>



// WEBPACK FOOTER //
// AuditModal.vue?64d0b7af